export default __webpack_public_path__ + "static/media/911Fonts.com_WebdingsRegular__-_911fonts.com_fonts_cOuv.2847da78.ttf";